import { render, staticRenderFns } from "./GeotagList.vue?vue&type=template&id=2d58b823&"
import script from "./GeotagList.vue?vue&type=script&lang=js&"
export * from "./GeotagList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports